/* eslint-disable no-underscore-dangle */
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import ToolTip from "@material-ui/core/Tooltip";
import Done from "@material-ui/icons/Done";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import addPlusIcon from "Assets/newicons/action/add-plus/outline/add-plus-outline-16px.svg";
import duplicate from "Assets/newicons/action/copy/outline/copy-outline-16-px.svg";
import deductible from "Assets/newicons/action/deductible/deductible.svg";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import editIcon from "Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import backArrow from "Assets/newicons/arrow/line-arrow/left/outline/line-arrow-left-outline-16px.svg";
import previewIcon from "Assets/newicons/user-interface/eye-show/outline/eye-show-outline-16px.svg";
import stop from "Assets/newicons/user-interface/stop/other-web (1)/icon/user-interface/stop/glyph/stop-glyph-16px.svg";
import tandoor from "Assets/newicons/user-interface/tandoor/glyph/tandoor-glyph-16px.svg";
import emptylist from "Assets/Svg/illustration-no-policy.svg";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import React from "react";
import Helmet from "react-helmet";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import { getFormattedDate } from "Utils";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  CommonApiAction,
  CommonReducerAction,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import {
  removeSaveProgress,
  setSaveProgress,
} from "../../../../../Actions/SaveProgressAction";
import CreatePolicyImage from "../../../../../Assets/Images/website_setup.svg";
import DrawerHeader from "../../../../../Component/Headers/drawerHeader";
import Stepper from "../../../../../Component/Stepper";
import { ApiReducerType, ReducersTypes } from "../../../../../Constants";
import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../business-configration/commons";
import Create from "./Create";
import Preview from "./Preview";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ActiveHeaders = [
  {
    key: "leavepolicyname",
    name: <FormattedMessage id="LbPolicyName" defaultMessage="Policy Name" />,
    type: TDTypeConsts.LEAVE_POLICY_NAME,
    style: { textAlign: "left" },
  },
  {
    key: "addeddate",
    name: <FormattedMessage id="LbCreatedBy" defaultMessage="Created On" />,
    type: TDTypeConsts.LEAVE_POLICY_DATE,
  },
  {
    key: "addedbyimagepath",
    name: <FormattedMessage id="LbCreatedBy" defaultMessage="Created By" />,
    type: TDTypeConsts.CREATED_BY,
  },
  {
    key: "assignedEmployeeList",
    name: (
      <FormattedMessage
        id="LbAssignedEmployee"
        defaultMessage="Assigned Employee"
      />
    ),
    type: TDTypeConsts.ASSIGNED_USER,
    style: { padding: "0" },
  },
  {
    key: "leavepolicyjson",
    name: (
      <FormattedMessage id="__LbPolicyStatus" defaultMessage="Leave Types" />
    ),
    type: TDTypeConsts.LEAVETYPES,
  },
  // {
  //   key: "editwithassignment",
  //   name: "",
  //   type: TDTypeConsts.EDIT_ASSIGNMENT_WITHOUT_HEADER,
  // },
  // {
  //   key: "delete",
  //   name: "",
  //   type: TDTypeConsts.DELETE_WITHOUT_HEADER,
  // },
  {
    key: "",
    name: "",
    type: TDTypeConsts.LEAVE_MORE_OPTIONS,
  },
];
const DraftHeaders = [
  {
    key: "leavepolicyname",
    name: <FormattedMessage id="LbPolicyName" defaultMessage="Policy Name" />,
    type: TDTypeConsts.POLICY_NAME,
    style: { textAlign: "left" },
  },
  {
    key: "addedbyimagepath",
    name: <FormattedMessage id="LbCreatedBy" defaultMessage="Created By" />,
    type: TDTypeConsts.CREATED_BY,
  },
  {
    key: "delete",
    name: "",
    type: TDTypeConsts.DELETE_WITHOUT_HEADER,
  },
];
const VersionsHeaders = [
  {
    key: "leavename",
    name: <FormattedMessage id="LbPolicyName" defaultMessage="Leave Name" />,
    type: TDTypeConsts.POLICY_VERSION_NAME,
    style: { textAlign: "left" },
  },
  {
    key: "updateddate",
    name: (
      <FormattedMessage id="LbCreatedBy" defaultMessage="Version Updated On" />
    ),
    type: TDTypeConsts.LEAVE_VERSION_DATE,
  },
  {
    key: "addedbyimagepath",
    name: <FormattedMessage id="LbCreatedBy" defaultMessage="Created By" />,
    type: TDTypeConsts.CREATED_BY,
  },
  // {
  //   key: "assignedEmployeeList",
  //   name: (
  //     <FormattedMessage
  //       id="LbAssignedEmployee"
  //       defaultMessage="Assigned Employee"
  //     />
  //   ),
  //   type: TDTypeConsts.ASSIGNED_USER,
  //   style: { padding: "0" },
  // },
  {
    key: "version",
    name: <FormattedMessage id="LbVersion" defaultMessage="Version" />,
    type: TDTypeConsts.OTHERS,
  },
];

let shouldCallAPI = true;
class index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      actionidList: "",
      headers: ActiveHeaders,
      value: 0,
      isloader: false,
      completed: {},
      activeStep: 0,
      parentid: null,
      rowdata: null,
      currentRoute: "list",
      AllStep: [],
      selectedRow: null,
      openpaper: false,
      selectedpolicyRow: null,
      Breadcrums: ["Track", "Leaves", "Policy"],
      editPre: true,
      page: 0,
      rowsPerPage: 15,
      offset: 0,
      fullcount: 1,
      isTrue: false,
      open: false,
      message: "",
      emplist: [],
      isdeactivate: false,
      versionleavelist: [],
      permissions: { readOnly: false, editable: false },
      newPolicyCreate: false,
    };
    this.renderduplicatePage = this.renderduplicatePage.bind(this);
    this.onMoreleaveOptionClick = this.onMoreleaveOptionClick.bind(this);
    this.onActionClick = this.onActionClick.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.goBack = this.goBack.bind(this);
    this.onDeactive = this.onDeactive.bind(this);
    this.onClickMarkAsDeductible = this.onClickMarkAsDeductible.bind(this);
    this.markAsDeductible = this.markAsDeductible.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("leavespolicy,navigation");
    if (
      this.props.history.location.pathname.includes("create") &&
      this.props.history.location.pathname.includes("config")
    ) {
      this.props.history.push(`${this.props.match.path}/list`);
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll1);
    const [isTrue, permissions] = CheckActionPermission("leavePolicy");
    this.setState({ isTrue });
    if (isTrue) {
      this.setState({ permissions }, () => {
        if (
          this.props.history.location.pathname.includes("versions") ||
          this.props.history.location.pathname.includes("view")
        ) {
          this.props.history.push(`${this.props.match.path}/list`);
          this.setState({ currentRoute: "list", parentid: null });
        }
        if (!this.props.history.location.pathname.includes("create")) {
          this.props.CommonReducerAction(ReducersTypes.INITLEAVESPOLICY, {});
        }
        this.callAllLeavePolicy();
        if (!this.state.permissions.editable) {
          const index1 = ActiveHeaders.findIndex(
            (x) => x.type == TDTypeConsts.LEAVE_MORE_OPTIONS,
          );
          if (index1 != -1) {
            ActiveHeaders.splice(index1, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index = DraftHeaders.findIndex(
            (x) => x.type == TDTypeConsts.DELETE_WITHOUT_HEADER,
          );
          if (index != -1) {
            DraftHeaders.splice(index, 1);
          }
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll1);
  }

  onDeactive(leaveselectedpolicy) {
    const data = {
      leaveid: leaveselectedpolicy.leaveid,
      leavetypeid: leaveselectedpolicy.leavetypeid,
      leavecategoryid: leaveselectedpolicy.leavecategoryid,
    };

    this.props.enqueueSnackbar(
      "Are you sure you want to deactivate this leave type?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            // disabled={this.props.issaveinprogress}
            onClick={() => {
              this.setState({
                createmenu: false,
              });
              this.props.closeSnackbar();
              instance
                .post("/leaves/disableleave", data)
                .then(() => {
                  this.props.enqueueSnackbar("Deactivated successfully", {
                    variant: "success",
                  });
                  this.setState(
                    {
                      createmenu: false,
                      openpaper: false,
                      open: false,
                      offset: 0,
                      emplist: [],
                      fullcount: 1,
                    },
                    () => this.callAllLeavePolicy(),
                  );
                })
                .catch((error) => {
                  this.props.enqueueSnackbar(
                    error.response
                      ? error.response.data.error.message
                      : error.message,
                    { variant: "error" },
                  );
                });
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  }

  onMoreleaveOptionClick(event, row) {
    // console.log('row: ', row);
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  onActionClick(event, row) {
    this.setState({
      openpaper: !this.state.openpaper,
      create_anchorEl: event.currentTarget,
      selectedpolicyRow: row,
    });
  }

  closeDrawer() {
    this.setState({
      open: false,
      selectedPolicy: null,
      createmenu: false,
      openpaper: false,
    });
  }

  setSelectedPolicy = (policy) => {
    // console.log("policy: ", policy);
    this.setState({ selectedPolicy: policy, open: true });
  };

  handleScroll1 = () => {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom >= Math.floor(window.innerHeight * 0.65)) {
      if (shouldCallAPI) {
        if (this.state.fullcount > this.state.offset) {
          shouldCallAPI = false;
          this.setState(
            {
              offset: this.state.offset + this.state.rowsPerPage,
            },
            () => this.callAllLeavePolicy(),
          );
          setTimeout(() => {
            shouldCallAPI = true;
          }, 2000);
        }
      }
    }
  };

  componentWillReceiveProps(props) {
    if (
      !props.history.location.pathname.includes("create") &&
      !props.history.location.pathname.includes("view") &&
      !props.history.location.pathname.includes("versions") &&
      !props.history.location.pathname.includes("list")
    ) {
      props.history.push(`${props.match.path}/list`);
    }

    if (
      props.LEAVES_POLICY.IsFulfilled &&
      props.LEAVES_POLICY.Data[0] &&
      props.history.location.pathname.includes("versions")
    ) {
      const fullcount = props.LEAVES_POLICY.Data[0].fullcount
        ? props.LEAVES_POLICY.Data[0].fullcount
        : 0;
      let versionleavelist = [];
      props.LEAVES_POLICY.Data.length > 0 &&
        (versionleavelist = [...props.LEAVES_POLICY.Data]);
      this.setState({
        emplist: [],
        versionleavelist,
        headers: VersionsHeaders,
      });
      if (this.state.fullcount != fullcount) this.setState({ fullcount });
    }
    if (!props.history.location.pathname.includes(this.state.currentRoute)) {
      if (props.history.location.pathname.includes("versions")) {
        this.setState(
          { Breadcrums: this.state.Breadcrums, currentRoute: "versions" },
          () => {
            this.setState({ headers: VersionsHeaders });
          },
        );
      } else if (props.history.location.pathname.includes("view")) {
        this.setState({ currentRoute: "view" });
      } else if (props.history.location.pathname.includes("create")) {
        this.setState({ currentRoute: "create" });
      } else {
        // console.log('id5: ');
        this.setState(
          {
            currentRoute: props.history.location.pathname.includes("list")
              ? "list"
              : "",
            parentid: null,
            headers: ActiveHeaders,
            offset: 0,
            value: 0,
            fullcount: 1,
            emplist: [],
            versionleavelist: [],
          },
          () => {
            this.callAllLeavePolicy();
          },
        );
      }
    }
    // }
  }

  handleChange = (event, value, policyid = null) => {
    if (this.state.value == value) return false;
    this.setState(
      {
        value,
        page: 0,
        rowsPerPage: 15,
        offset: 0,
        emplist: [],
      },
      () => {
        switch (this.state.value) {
          case 0: {
            this.setState({ headers: ActiveHeaders });
            break;
          }
          case 1: {
            this.setState({ headers: DraftHeaders });
            break;
          }
          default:
            break;
        }
        this.callAllLeavePolicy(policyid);
      },
    );
  };

  _onCreate = () => {
    this.props.CommonReducerAction(ReducersTypes.INITLEAVESPOLICY, {});
    // console.log('this.props.CommonReducerAction(ReducersTypes.INITLEAVESPOLICY, {});: ', this.props.CommonReducerAction(ReducersTypes.INITLEAVESPOLICY, {}));
    const { match } = this.props;
    localStorage.setItem("selectedleaves", "");
    // this.InitLeavesPolicy();
    // const selectedleaves1 = localStorage.getItem("selectedleaves");
    // console.log('selectedleaves1: ', selectedleaves1);
    this.props.history.push({
      pathname: `${match.path}/create`,
      state: { permissions: this.state.permissions },
    });
    this.setState({ completed: {}, newPolicyCreate: true });
  };

  getText() {
    return (
      <span>
        {this.state.value == 0 ? (
          <FormattedMessage
            id="leavePolicyConcept"
            defaultMessage="In a leave policy, you can define a wide variety of rules on how the leaves will be governed. Some of the main functionality in Leave Policy includes accrual of leave credit, carrying forward of unused leaves, treatment of leave applications exceeding available balance, and much more."
          />
        ) : (
          <span>
            Saved drafts allow you to store policies that you have not finished
            creating.
          </span>
        )}
      </span>
    );
  }

  _renderCreate = () => (
    <CreateComp
      text={this.getText()}
      heading={this.state.value == 0 ? "Concept of Policy" : "No drafts saved"}
      onCreate={this._onCreate}
      imageSrc={this.state.value == 0 ? CreatePolicyImage : emptylist}
      permissions={this.state.permissions}
    />
  );

  showLoader() {
    return <div className="pre-loader">Loading...</div>;
  }

  async onEdit(row, isviewmode, id = null) {
    const { rowdata } = this.state;
    // console.log('rowdata: ', rowdata);
    // console.log("onEdit");
    const { match } = this.props;
    this.setState({
      newPolicyCreate: false,
      createmenu: false,
    });
    await this.props.CommonReducerAction(ReducersTypes.LEAVESPOLICY, {
      ...this.props.InitLeavesPolicy,
      leavepolicyid: id ? rowdata[0].leavepolicy : row.leavepolicy,
      leavepolicyname: id ? rowdata[0].leavepolicyname : row.leavepolicyname,
      isdraft: id ? rowdata[0].isdraft : row.isdraft,
      isviewmode,
      description: id ? rowdata[0].description : row.description,
    });
    if (id) {
      this.renderduplicatePage();
    } else {
      localStorage.setItem("selectedleaves", "");
      // this.InitLeavesPolicy();
      // const selectedleaves1 = localStorage.getItem("selectedleaves");
      this.props.history.push({
        pathname: `${match.path}/create`,
        state: { permissions: this.state.permissions },
      });
    }
  }

  onVersionEdit(row) {
    // console.log("onVersionEdit");
    const { InitLeavesPolicy } = this.props;
    InitLeavesPolicy.isviewmode = true;
    InitLeavesPolicy.isdraft = false;
    InitLeavesPolicy.leaveid = row.leaveid;
    InitLeavesPolicy.leavepolicyid = row.leavepolicyid;
    InitLeavesPolicy.leavetypeid = row.leavetypeid;
    const { match } = this.props;
    this.props.CommonReducerAction(ReducersTypes.LEAVESPOLICY, {
      ...InitLeavesPolicy,
      ...row,
    });
    localStorage.setItem("selectedleaves", "");
    this.props.history.push({
      pathname: `${match.path}/create`,
      state: { permissions: this.state.permissions },
    });
  }

  onLeavePlanSelect(row, option, isviewmode) {
    // console.log("onLeavePlanSelect");
    this.setState({
      createmenu: false,
      open: false,
      openpaper: false,
    });
    const { match } = this.props;
    this.props.CommonReducerAction(ReducersTypes.LEAVESPOLICY, {
      ...this.props.InitLeavesPolicy,
      leavepolicyid: row.leavepolicy,
      leavepolicyname: row.leavepolicyname,
      isdraft: row.isdraft,
      isviewmode,
      description: row.description,
      leaveid: option.leaveid,
      leavetypeid: option.leavetypeid,
    });
    localStorage.setItem("selectedleaves", "");
    this.props.history.push({
      pathname: `${match.path}/create`,
      state: { permissions: this.state.permissions },
    });
  }

  _renderVersionList = (row, option) => {
    const { match } = this.props;
    this.props.history.push(`${match.path}/versions`);
    this.setState({ headers: VersionsHeaders });
    const data = {
      leavepolicyid: row.leavepolicy,
      leaveid: option.leaveid,
      leavetypeid: option.leavetypeid,
      leavecategoryid: option.leavecategoryid,
    };
    this.props.CommonApiAction(
      ApiReducerType.LEAVES_POLICY,
      "post",
      "leaves/getleaveversion",
      data,
    );
  };

  onEditAssignment = (item) => {
    console.log("item: ", item);
    this.setState({ createmenu: false });
    const { issaveinprogress } = this.props;
    // console.log('issaveinprogress: ', issaveinprogress);

    // console.log('item: ', item);
    const data = {
      leavepolicyid: item.leavepolicy,
    };
    this.props.enqueueSnackbar(
      "You will be redirected to the draft section for editing. Do you want to duplicate this leave policy?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            disabled={this.props.issaveinprogress}
            onClick={() => {
              if (!issaveinprogress) {
                // console.log('issaveinprogress: ', issaveinprogress);
                this.props.setSaveProgress(true);
                instance
                  .post("leaves/duplicateleavepolicy", data)
                  .then((result) => {
                    this.props.closeSnackbar();
                    this.props.removeSaveProgress();
                    if (result.data.result.length > 0) {
                      // console.log("result.data.result: ", result.data.result);
                      this.setState(
                        {
                          // value: 1,
                        },
                        (e) =>
                          this.handleChange(
                            e,
                            1,
                            result.data.result[0].leavepolicyid,
                          ),
                      );
                    }
                    //  else {
                    //   this.setState({ loading: false });
                    //   this.props.enqueueSnackbar(
                    //     "Please create at least one deduction component",
                    //     { variant: "error" },
                    //   );
                    // }
                  });
              }
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  };

  renderduplicatePage(id) {
    const { match } = this.props;
    this.setState({
      isloader: false,
    });
    localStorage.setItem("selectedleaves", "");
    this.props.history.push({
      pathname: `${match.path}/create`,
      state: { permissions: this.state.permissions },
    });
  }

  checkCompleted = () => {
    const completed = {};
    this.setState({ completed });
  };

  onDelete = (row) => {
    instance
      .delete(`/leaves/leavepolicy/${row.leavepolicy}`)
      .then(() => {
        this.props.enqueueSnackbar("Deleted Successfully", {
          variant: "success",
        });
        this.setState({ offset: 0, emplist: [], createmenu: false }, () => {
          this.callAllLeavePolicy();
        });
      })
      .catch((error) => {
        this.setState({ createmenu: false });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  _renderList = () => (
    <List
      list={this.state.emplist}
      headers={this.state.headers}
      headerIndex={0}
      onCreate={this._onCreate}
      _renderVersionList={this._renderVersionList.bind(this)}
      onEdit={this.onEdit.bind(this)}
      onDelete={this.onDelete.bind(this)}
      onEditAssignment={this.onEditAssignment}
      onMoreleaveOptionClick={(e, row) => this.onMoreleaveOptionClick(e, row)}
      onLeavePlanSelect={this.onLeavePlanSelect.bind(this)}
      module={"Leaves policie"}
      goTo={this.props.goTo}
      sortOrder="desc"
      permissions={this.state.permissions}
    />
  );

  _renderTab = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        <div
          position="static"
          color="default"
          className="bottom-border dashboard-tab-width"
        >
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {this._renderList()}
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );

  Cancel() {
    console.log("Cancel: ");
    localStorage.setItem("selectedleaves", "");
    this.props.CommonReducerAction(ReducersTypes.INITLEAVESPOLICY, {});
    for (const step of this.state.AllStep) {
      step.isError = false;
    }
    const { Breadcrums } = this.state;
    Breadcrums.splice(3);
    this.setState({ Breadcrums, AllStep: this.state.AllStep }, () => {
      this.props.history.push(`${this.props.match.path}/list`);
    });
  }

  Save(isdraft) {
    const { InitLeavesPolicy } = this.props;
    InitLeavesPolicy.isdraft = isdraft;
    instance
      .post("/leaves/leavepolicy", InitLeavesPolicy)
      .then(() => {
        this.callAllLeavePolicy();
        this.props.enqueueSnackbar("Saved successfully", {
          variant: "success",
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  callAllLeavePolicy = (id = null) => {
    // if(id) {
    this.setState({
      isloader: id ? true : false,
    });
    // }
    let status;
    this.state.value == 0
      ? (status = 1)
      : this.state.value == 1
      ? (status = 2)
      : (status = 0);
    if (this.state.value == 0) {
      this.setState({ headers: ActiveHeaders });
    } else if (this.state.value == 1) {
      this.setState({ headers: DraftHeaders });
    }
    if (this.state.offset < this.state.fullcount) {
      this.props
        .CommonApiAction(
          ApiReducerType.LEAVES_POLICY,
          "get",
          `leaves/allleavepolicybysubid/${this.state.rowsPerPage}/${this.state.offset}/${status}`,
          {},
        )
        .then((res) => {
          const list = res.value.data.result;
          const fullcount = list[0] ? list[0].fullcount : 1;
          let emplist = [];
          let rowdata = null;
          emplist = [...this.state.emplist, ...list];
          // console.log('emplist: ', emplist);
          rowdata = emplist.filter((x) => x.leavepolicy == id);
          // console.log('rowdata: ', rowdata);

          if (id) {
            // console.log('id: ', id);
            this.setState(
              {
                rowdata,
                emplist,
                versionleavelist: [],
                fullcount,
              },
              () => this.onEdit(this.state.rowdata, false, id),
            );
          } else {
            // console.log('id1: ', id);
            this.setState({
              emplist,
              versionleavelist: res.value.data.result,
              fullcount,
            });
          }
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  };

  _renderForm = () => (
    <div className="content-outer-wrapper">
      <Stepper
        AllStep={this.state.AllStep}
        onRef={(ref) => {
          this.child = ref;
        }}
        setStep={this.setStep.bind(this)}
        completed={this.state.completed}
      />
      <div className="draftbutton-wrapper">
        <div className="draftclosebutton" onClick={() => this.Cancel()}>
          X <span className="draftclosebutton-text">Close</span>
        </div>
        {this.state.activeStep == this.state.AllStep.length - 1 ? (
          <div
            className="draftbutton-innerwrapper"
            onClick={() => this.Save(false)}
          >
            <span className="draftbutton">
              <DoneAllIcon />
              <span className="draft-option">Save </span>
            </span>
          </div>
        ) : this.props.InitLeavesPolicy.isdraft ? (
          <div
            className="draftbutton-innerwrapper"
            onClick={() => this.Save(true)}
          >
            <span className="draftbutton">
              <Done />
              <span className="draft-option">Save As Draft</span>
            </span>
          </div>
        ) : (
          <div
            className="draftbutton-innerwrapper"
            onClick={() => this.Save(false)}
          >
            <span className="draftbutton">
              <DoneAllIcon />
              <span className="draft-option">Save </span>
            </span>
          </div>
        )}
      </div>
    </div>
  );

  goBack() {
    this.props.history.push(`${this.props.match.path}/list`);
    this.setSelectedPolicy(this.state.selectedRow);
  }

  _renderVersion = () => (
    <div style={{ marginTop: -48 }}>
      <Grid container>
        <Grid item xs={12} md={12} sm={12} className="position-rel">
          <div
            className=" display-flex"
            style={{ position: "absolute", top: 0 }}
          >
            <img
              src={backArrow}
              onClick={this.goBack}
              className="cursor-pointer"
            ></img>
            <p className="large-text-dark margin-left-24">
              {" "}
              Leave type versions{" "}
            </p>
          </div>
          <div
            className="display-flex"
            style={{ position: "absolute", top: 52 }}
          >
            <span className="small-dark">Leave type: &nbsp;</span>
            <ToolTip
              title={
                this.state.selectedpolicyRow.leavetypename &&
                this.state.selectedpolicyRow.leavetypename
              }
              placement="top"
            >
              <span
                className="small-dark t-bold margin-right-32 ellipsis"
                style={{ naxWidth: 160 }}
              >
                {this.state.selectedpolicyRow &&
                  this.state.selectedpolicyRow.leavetypename &&
                  this.state.selectedpolicyRow.leavetypename}
              </span>
            </ToolTip>
            <span className="small-dark">Leave policy name: &nbsp;</span>
            <ToolTip
              title={
                this.state.selectedpolicyRow.leavename &&
                this.state.selectedpolicyRow.leavename
              }
              placement="top"
            >
              <span
                className="small-dark t-bold ellipsis"
                style={{ width: 160 }}
              >
                {this.state.selectedpolicyRow &&
                  this.state.selectedpolicyRow.leavename &&
                  this.state.selectedpolicyRow.leavename}
              </span>
            </ToolTip>
          </div>

          {/* this.state.selectedpolicyRow */}

          <List
            list={this.state.versionleavelist}
            headers={this.state.headers}
            headerIndex={0}
            // onCreate={this._onCreate}
            _renderVersionList={this._renderVersionList.bind(this)}
            onVersionEdit={this.onVersionEdit.bind(this)}
            onLeavePlanSelect={this.onLeavePlanSelect.bind(this)}
            module={"Leaves version policie"}
            goTo={this.props.goTo}
            sortOrder="desc"
            permissions={this.state.permissions}
            hidecount
          />

          <div className="stepper-action-wrapper">
            <div className="stepper-left-action">
              <Button
                className="btn btn-trans margin-right-16"
                variant="contained"
                // onClick={() => this.props.history.push(`${this.props.match.path}/list`)}
                onClick={this.goBack}
              >
                Go Back
              </Button>
              {/* )} */}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  showLoader1() {
    return (
      <div
        className="pre-loader"
        style={{
          marginLeft: "50%",
          transform: "translateX(-50%)",
        }}
      >
        Please wait, duplicating your leave policy...
      </div>
    );
  }

  EditPreview = () => {
    localStorage.setItem("selectedleaves", "");
    this.props.history.push({
      pathname: `${this.props.match.path}/create`,
      state: { permissions: this.state.permissions },
    });
  };

  onClickMarkAsDeductible(objLeaveType) {
    const arrLeavePolicy = this.state.selectedRow.leavepolicyjson || [];
    const objPvsDeductiblePolicy = arrLeavePolicy.find(
      (leave) =>
        leave.isdeductible && leave.leavetypeid === objLeaveType.leavetypeid,
    );
    this.props.enqueueSnackbar(
      objPvsDeductiblePolicy
        ? `${objPvsDeductiblePolicy.leavename} is already marked as deductible. Do you want to now make deductions from ${objLeaveType.leavename}?`
        : `Do you want to make deductions from ${objLeaveType.leavename}?`,
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.markAsDeductible(objLeaveType)}
          >
            {" "}
            Yes{" "}
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            {" "}
            No{" "}
          </Button>,
        ],
      },
    );
  }

  markAsDeductible(objLeaveType) {
    const data = {
      leaveid: objLeaveType.leaveid,
      leavepolicyid: this.state.selectedRow.leavepolicy,
      leavetypeid: objLeaveType.leavetypeid,
      leavecategoryid: objLeaveType.leavecategoryid,
    };

    this.setState({
      createmenu: false,
    });
    this.props.closeSnackbar();
    instance
      .post("/leaves/markdeductibleleave", data)
      .then(() => {
        this.props.enqueueSnackbar("Marked as deductible successfully", {
          variant: "success",
        });
        this.closeDrawer();
        this.setState(
          {
            createmenu: false,
            openpaper: false,
            open: false,
            offset: 0,
            emplist: [],
            fullcount: 1,
          },
          () => this.callAllLeavePolicy(),
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  _renderViewComponent = () => (
    <Grid container>
      <Grid item xs={12} md={12} sm={12}>
        <Preview />
      </Grid>
    </Grid>
  );

  _renderComponent = () => {
    const { LEAVES_POLICY } = this.props;
    let status;
    this.state.value == 0
      ? (status = 1)
      : this.state.value == 1
      ? (status = 2)
      : (status = 0);
    const isDraft = status == 2;
    return (
      <div>
        <Grid container>
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {this.state.isloader == true ? (
                this.showLoader1()
              ) : (
                <div>
                  {LEAVES_POLICY.Data.length == 0 &&
                  !LEAVES_POLICY.IsPending &&
                  !isDraft
                    ? this._renderCreate()
                    : this._renderTab()}
                  {/* {this._renderCreate()} */}
                  {/* {LEAVES_POLICY.Data.length == 0 && !LEAVES_POLICY.IsPending ? this._renderCreate() : this._renderTab()} */}
                </div>
              )}
              {/* <Dialog
              fullWidth={true}
              maxWidth="sm"
              open={this.state.isloader}
              // onClose={() => this.setState({ openDialog: false, empform1: null })}
              aria-labelledby="max-width-dialog-title"
              classes={{
                scrollPaper: "no-shadow bg-transparent",
                paper: "no-shadow bg-transparent",
              }}
            >
              <DialogContent>
                <div
                  className="progess-wrapper"
                  style={{
                    position: "relative",
                    width: 120,
                    height: 120,
                    margin: "0 auto",
                    color: "#fff",
                  }}
                >
                  <CircularProgress
                    className="goal-progress"
                    variant="static"
                    value={this.state.isloader}
                    color="inherit"
                  />
                  <div
                    className="progress-line"
                    style={{ borderColor: "#fff" }}
                  ></div>
                  <div
                    className="vertical-center text-center"
                    style={{ height: 30 }}
                  >
                    <span
                      style={{
                        display: "block",
                        fontSize: 24,
                        color: "#fff",
                        fontWeight: "bold",
                      }}
                    >
                      {""}%
                </span>
                  </div>
                </div>
              </DialogContent>
            </Dialog> */}
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  };

  render() {
    const { classes, match, history } = this.props;
    const language = this.props.Language.attendancepolicy;
    const goTo = (path) => {
      history.push(path);
    };
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="innerwrapper-full-width" onScroll={this.handleScroll1}>
          <Helmet>
            <title>{headersList.Config.LeavePolicy.header}</title>
          </Helmet>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              <div className="common-menubar-header">
                {this.props.history.location.pathname ===
                  "/config/track/leave/policy/list" && (
                  <div>
                    <Tabs
                      value={this.state.value}
                      onChange={this.handleChange.bind(this)}
                      indicatorColor="#fff"
                      textColor="#fff"
                      scrollButtons="auto"
                    >
                      <Tab
                        label={
                          <FormattedMessage
                            id="LbActive"
                            defaultMessage="Active"
                          />
                        }
                        className={`tabheading ${
                          this.state.value == 0
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                      <Tab
                        label={
                          <FormattedMessage
                            id="LbDraft"
                            defaultMessage="Draft"
                          />
                        }
                        className={`tabheading ${
                          this.state.value == 1
                            ? "active-tab1"
                            : "inactive-tab1"
                        } `}
                      />
                    </Tabs>
                    <div className="tab-border" />
                  </div>
                )}
              </div>
              <Popover
                open={this.state.createmenu}
                anchorEl={this.state.create_anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                onClose={() => this.setState({ createmenu: false })}
                className="margin-top-8"
              >
                <Paper className="rounded-rectangle-div">
                  <div>
                    <MenuListComponent>
                      {this.state.permissions.editable && (
                        <ListItem
                          className="padding-top-0 padding-bottom-0 cursor-pointer"
                          onClick={() =>
                            this.onEditAssignment(this.state.selectedRow)
                          }
                        >
                          <ListItemIcon>
                            <img src={duplicate}></img>
                          </ListItemIcon>
                          <ListItemText style={{ padding: 0 }}>
                            <span className="small-dark-secondary">
                              Duplicate in draft
                            </span>
                          </ListItemText>
                        </ListItem>
                      )}
                      {this.state.permissions.editable && (
                        <ListItem
                          className="padding-top-0 padding-bottom-0 cursor-pointer"
                          onClick={() =>
                            this.onEdit(this.state.selectedRow, false)
                          }
                        >
                          <ListItemIcon>
                            <img src={addPlusIcon}></img>
                          </ListItemIcon>
                          <ListItemText style={{ padding: 0 }}>
                            <span className="small-dark-secondary">
                              Add new leave type to policy
                            </span>
                          </ListItemText>
                        </ListItem>
                      )}
                      <ListItem
                        className="padding-top-0 padding-bottom-0 cursor-pointer"
                        onClick={() =>
                          this.setSelectedPolicy(this.state.selectedRow)
                        }
                      >
                        <ListItemIcon>
                          <img src={editIcon}></img>
                        </ListItemIcon>
                        <ListItemText style={{ padding: 0 }}>
                          <span className="small-dark-secondary">
                            View / edit leave types
                          </span>
                        </ListItemText>
                      </ListItem>
                      {this.state.permissions.editable && (
                        <ListItem
                          className="padding-top-0 padding-bottom-0 cursor-pointer"
                          onClick={() => this.onDelete(this.state.selectedRow)}
                        >
                          <ListItemIcon>
                            <img src={deleteIcon}></img>
                          </ListItemIcon>
                          <ListItemText style={{ padding: 0 }}>
                            <span className="small-dark-secondary">
                              Delete policy
                            </span>
                          </ListItemText>
                        </ListItem>
                      )}
                    </MenuListComponent>
                  </div>
                </Paper>
              </Popover>
              <Drawer
                className={classes.drawer}
                classes={{
                  paper: "width40 padding16",
                }}
                anchor="right"
                open={this.state.open}
                onClose={this.closeDrawer}
              >
                {/* <div className="padding-bottom-10 text-align-center">
            <span style={{ fontWeight: "bold", fontSize: 14 }}>
              Policy Name: <strong className="text-color-blue">{get(selectedPolicy, "leavepolicyname", "")}</strong>
            </span>
          </div> */}
                <DrawerHeader
                  header="View & edit leave types"
                  isbackarrow={false}
                  closeDrawer={this.closeDrawer}
                />

                <div
                  style={{
                    marginBottom: 120,

                    paddingRight: 16,
                  }}
                  className="thin-scroll-on-hover"
                >
                  <span
                    className="normal-dark-secondary"
                    style={{ marginBottom: 4 }}
                  >
                    Policy Name: &nbsp;
                    <span className="normal-dark">
                      {this.state.selectedPolicy &&
                        this.state.selectedPolicy.leavepolicyname}
                    </span>
                  </span>
                  {this.state.selectedPolicy &&
                    this.state.selectedPolicy.leavepolicyjson.map((x) => (
                      <div
                        className="rounded-rectangle-div"
                        style={{
                          backgroundColor: x.isdisable ? "#ececec" : "#fff",
                          marginTop: 16,
                          padding: 16,
                        }}
                      >
                        <p className="normal-dark">
                          {x.leavename}
                          {x.isdeductible ? (
                            <span
                              className=""
                              style={{
                                marginLeft: 16,
                                fontSize: 12,
                                padding: "2px 16px",
                                borderRadius: 20,
                                border: "solid 1px #008985",
                                background: "#dcf2f1",
                                color: "#008985",
                                height: 16,
                              }}
                            >
                              Deductible
                            </span>
                          ) : (
                            ""
                          )}
                        </p>
                        <div
                          className="display-flex"
                          style={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 4,
                          }}
                        >
                          <p className="small-dark-secondary">
                            Type: {x.leavetypename}{" "}
                          </p>
                          <div
                            style={{
                              cursor: "pointer",
                              alignItems: "center",
                              padding: "8px 16px",
                            }}
                            className="display-flex rounded-rectangle-div"
                            onClick={(e) => this.onActionClick(e, x)}
                          >
                            <span
                              className="small-dark"
                              style={{ marginRight: 8 }}
                            >
                              {" "}
                              Actions{" "}
                            </span>
                            <img src={tandoor}></img>
                          </div>
                        </div>
                        <div className="display-flex">
                          <p
                            className="small-dark-secondary"
                            style={{
                              borderRight: "1px solid #d8d8d8",
                              paddingRight: 16,
                            }}
                          >
                            {" "}
                            Updated on: {getFormattedDate(x.updatedon)}
                          </p>
                          <p
                            className="small-dark-secondary"
                            style={{ paddingLeft: 16 }}
                          >
                            {x.versioncount == 0
                              ? "No version(s)"
                              : `${x.versioncount} version(s)`}
                          </p>
                        </div>
                        {x.isdisable && (
                          <p className="small-dark-secondary margin-top-8">
                            Deactivated
                          </p>
                        )}
                      </div>
                    ))}
                </div>

                <div
                  style={{
                    position: "fixed",
                    bottom: 0,

                    background: "#fff",
                    width: "calc(40% + 32px)",
                    marginLeft: -16,
                    padding: 16,
                    boxShadow: "inset 0px 1px 0px #d2d2d2",
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn btn-trans"
                    color="primary"
                    onClick={this.closeDrawer}
                  >
                    Close
                  </Button>
                </div>
              </Drawer>
              <Popover
                open={this.state.openpaper}
                anchorEl={this.state.create_anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                onClose={() => this.setState({ openpaper: false })}
                className="margin-top-8"
              >
                <Paper style={{ width: 230 }}>
                  <div>
                    <MenuListComponent>
                      {this.state.permissions.editable &&
                        this.state.selectedpolicyRow &&
                        !this.state.selectedpolicyRow.isdisable && (
                          <ListItem
                            className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                            onClick={() => {
                              this.onLeavePlanSelect(
                                this.state.selectedPolicy,
                                this.state.selectedpolicyRow,
                                false,
                              );
                            }}
                          >
                            <ListItemIcon>
                              <img src={editIcon}></img>
                            </ListItemIcon>
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                Edit leave type
                              </span>
                            </ListItemText>
                          </ListItem>
                        )}
                      {this.state.selectedpolicyRow &&
                        this.state.selectedpolicyRow.versioncount != 0 && (
                          <ListItem
                            className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                            onClick={() =>
                              this.setState(
                                {
                                  openpaper: false,
                                  open: false,
                                  createmenu: false,
                                },
                                () =>
                                  this._renderVersionList(
                                    this.state.selectedPolicy,
                                    this.state.selectedpolicyRow,
                                  ),
                              )
                            }
                          >
                            <ListItemIcon>
                              <img src={previewIcon}></img>
                            </ListItemIcon>
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                View older versions
                              </span>
                            </ListItemText>
                          </ListItem>
                        )}
                      {this.state.selectedpolicyRow &&
                        this.state.selectedpolicyRow.leavetypeid != 3 &&
                        this.state.selectedpolicyRow.leavetypeid != 4 &&
                        !this.state.selectedpolicyRow.isdisable &&
                        !this.state.selectedpolicyRow.isdeductible && (
                          <ListItem
                            className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                            onClick={() =>
                              this.onClickMarkAsDeductible(
                                this.state.selectedpolicyRow,
                              )
                            }
                          >
                            <ListItemIcon>
                              <img src={deductible}></img>
                            </ListItemIcon>
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                Mark as deductible
                              </span>
                            </ListItemText>
                          </ListItem>
                        )}
                      {this.state.permissions.editable &&
                        this.state.selectedpolicyRow &&
                        this.state.selectedpolicyRow.leavetypeid != 4 &&
                        !this.state.selectedpolicyRow.isdisable && (
                          <ListItem
                            className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                            onClick={() =>
                              this.onDeactive(this.state.selectedpolicyRow)
                            }
                          >
                            <ListItemIcon>
                              <img src={stop}></img>
                            </ListItemIcon>
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                Deactivate leave type
                              </span>
                            </ListItemText>
                          </ListItem>
                        )}
                    </MenuListComponent>
                  </div>
                </Paper>
              </Popover>

              <main
                className="content-outer-wrapper-with-tab"

                // onClick={() => this.checkAnchor()}
              >
                <div className={classes.root}>
                  <Switch>
                    <Route
                      exact
                      path={`${match.path}/create`}
                      render={(props) => (
                        <Create
                          {...props}
                          goTo={goTo}
                          permissions={this.state.permissions}
                          newPolicyCreate={this.state.newPolicyCreate}
                        />
                      )}
                    />
                    <Route
                      exact
                      path={`${match.path}/versions`}
                      render={this._renderVersion}
                    />
                    <Route
                      exact
                      path={`${match.path}/list`}
                      render={this._renderComponent}
                    />
                    <Route
                      exact
                      path={`${match.path}`}
                      render={this._renderComponent}
                    />
                    <Route
                      exact
                      path={`${match.path}/view`}
                      render={this._renderViewComponent}
                    />
                  </Switch>
                </div>
              </main>
            </div>
          )}
        </div>
      </IntlProvider>
    );
  }
}
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
  LEAVES_POLICY: state.LEAVES_POLICY,
  issaveinprogress: state.SaveInProgressReducer.issaveinprogress,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      CommonApiAction: (type, method, url, data) =>
        CommonApiAction(type, method, url, data),
      setHelperText: (data) => setHelperText(data),
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(index)));
